import { Role } from '@/modules/auth/shared/dtos/user-role.dto'

export const truncateWalletAddress = (address: string) => {
  return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`
}

export const addAccess = (userScope: Role, access: Role) => {
  const scope = (userScope && userScope.split(' ')) || []
  if (!scope.includes(access)) {
    scope.push(access)
  }
  return scope.join(' ')
}

export const checkAccess = (userScope: Role, access: Role) => {
  const scope: string[] = (userScope && userScope.split(' ')) || []
  return scope.includes(access)
}

export const isInEnum = <T extends Record<string, string>>(value: string, enumObject: T): value is keyof T & string => {
  return Object.values(enumObject).includes(value)
}
